import React from "react";
import SettingsPage from "../../components/Design/Settings/SettingsPage";
import SettingsPageContent from "../../components/Design/Settings/SettingsPageContent";
import { useApiStates } from "../../state/Store";
import WorkerTable from "./WorkerTable";

const WorkerScreen: React.FC = () => {
    const api = useApiStates("workers", "roles", "executions");

    return (
        <SettingsPage title="Worker">

            <SettingsPageContent api={api}>

                <WorkerTable
                    executions={api.executions.value ?? []}
                    roles={api.roles.value ?? []}
                    workers={api.workers.value ?? []} />

            </SettingsPageContent>

        </SettingsPage>
    );
};

export default WorkerScreen;
